import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Landing from './components/Landing';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import CharacterSwap from './components/CharacterSwap';
import AvatarLive from './components/AvatarLive';
import ImageGen from './components/ImageGen';
import VideoGen from './components/VideoGen';
import './App.css';

function App() {
  const token = localStorage.getItem('token');
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={token ? <Dashboard /> : <Navigate to="/login" />}>
          <Route index element={<CharacterSwap />} />
          <Route path="avatar" element={<AvatarLive />} />
          <Route path="image" element={<ImageGen />} />
          <Route path="video" element={<VideoGen />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
